import React, { useState } from 'react';
import { uploadFileRequest } from '../../../hooks/api-methods/post-upload';

const UploadButton: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
  const [uploadedUrl, setUploadedUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0] || null;
    setFile(selectedFile);
    setUploadedUrl(null);
    setError(null);
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Selecteer eerst een bestand.');
      return;
    }

    try {
      setUploading(true);
      const result = await uploadFileRequest(file, 'uploads');
      setUploadedUrl(result.url);
      setError(null);
      window.location.reload();
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError('Er is een onbekende fout opgetreden.');
      }
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex-row-align">
      <input id="fileInput" type="file" onChange={handleFileChange} className="hidden" />
      <label htmlFor="fileInput" className="btn btn-small btn-second-color cursor-pointer">
        Kies bestand
      </label>
      {file && <p className="text-gray-600 text-sm break-all">Gekozen bestand: {file.name}</p>}
      <button
        className="button button-small button-sec"
        onClick={handleUpload}
        disabled={!file || uploading}
      >
        {uploading ? 'Bezig met uploaden...' : 'Uploaden'}
      </button>
      {error && <p>{error}</p>}
      {uploadedUrl && <p className="text-green-600 text-sm break-all">✅ Upload gelukt! </p>}
    </div>
  );
};

export default UploadButton;
